import { BaseService, RequestType } from "@intech/react-service";
import { RelacionamentoEntidade } from "../entidades";

class Relacionamento extends BaseService {
  constructor() {
    super("relacionamento");
  }

  Enviar = (relacionamentoEntidade: RelacionamentoEntidade) =>
    this.CreateRequest(RequestType.POST, "Enviar", relacionamentoEntidade);

}

export const RelacionamentoService = new Relacionamento();
